import { mdiChevronDown } from '@mdi/js'
import { NavMdiIcon } from '../NavTabIcons'

/** Shared MDI chevron size for all `BuxusAccordion` instances (mobile List.Accordion parity). */
export const BUXUS_ACCORDION_CHEVRON_SIZE = 1.35

type Props = {
  className?: string
}

/** Outline chevron used by every Buxus accordion trigger. */
export function BuxusAccordionChevron({ className }: Props) {
  return (
    <NavMdiIcon
      path={mdiChevronDown}
      size={BUXUS_ACCORDION_CHEVRON_SIZE}
      className={['buxus-accordion-chevron-icon', className].filter(Boolean).join(' ')}
    />
  )
}
